export default {
  title: '极致互联',
  logo: 'TC',
  author: '',
  whiteList: ['/login', '/404', '/401', '/lock'],
  info: {
    title: 'TC 微服务开发平台',
    list: [
      '是一个基于Spring Cloud、oAuth2.0开发基于Vue前后分离的开发平台',
      ' 是一个基于vue+vuex+vue-router快速后台管理系统，采用token交互验证方式。'
    ]
  },
  wel: {
    title: '极致互联微服务开发平台',
    list: [
      '是一个基于Spring Cloud、oAuth2.0开发基于Vue前后分离的开发平台',
      ' 是一个基于vue+vuex+vue-router快速后台管理系统，采用token交互验证方式。'
    ]
  }
}
